<template>
  <div class="fixed-fields-notice-wrapper">
    <v-divider class="fixed-fields-notice__top-divider" />
    <div class="fixed-fields-notice" :class="`fixed-fields-notice--${mode}`">
      <div class="fixed-fields-notice__icon-box">
        <v-icon color="#ffffff" size="14">mdi-information</v-icon>
      </div>
      <div class="fixed-fields-notice__content">
        <h3 class="fixed-fields-notice__title">
          Estos campos ya aparecen como campos fijos
        </h3>
        <p class="fixed-fields-notice__desc">
          Los siguientes campos ya se muestran de forma automática en los
          formularios de registro. Evita crearlos nuevamente para no duplicar
          la información<template v-if="mode === 'memberships' && showPosition">. Ten en
          cuenta que <strong>Cargo/Posición</strong> aparece fijo únicamente
          en el formulario de submiembros</template>.
        </p>
        <div class="fixed-fields-notice__chips">
          <span
            v-for="field in baseFields"
            :key="field"
            class="ffn-chip ffn-chip--blue"
          >
            <span class="ffn-chip__check ffn-chip__check--blue">
              <v-icon size="10" color="#2563EB">mdi-check</v-icon>
            </span>
            {{ field }}
          </span>
          <span
            v-if="mode === 'memberships' && showPosition"
            class="ffn-chip ffn-chip--teal"
          >
            <span class="ffn-chip__check ffn-chip__check--teal">
              <v-icon size="10" color="#ffffff">mdi-check</v-icon>
            </span>
            Cargo/Posición
          </span>
          <span v-if="$slots.action" class="fixed-fields-notice__action">
            <slot name="action" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FixedFieldsNotice",
  props: {
    mode: {
      type: String,
      default: "default",
      validator: (v) => ["default", "memberships"].includes(v),
    },
    showPosition: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseFields: ["Nombre", "Apellido", "Correo"],
    };
  },
};
</script>

<style scoped>
.fixed-fields-notice-wrapper {
  width: 100%;
}
.fixed-fields-notice__top-divider {
  margin-bottom: 14px;
  border-color: #cdd9e6;
}
.fixed-fields-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  background-color: #eff6ff;
  border: 1px solid #d8e8ff;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  color: #1e293b;
  box-sizing: border-box;
}
.fixed-fields-notice__icon-box {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  background-color: #3b82f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fixed-fields-notice__content {
  flex: 1;
  min-width: 0;
}
.fixed-fields-notice__title {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  text-align: left;
}
.fixed-fields-notice__desc {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #334155;
  max-width: 720px;
}
.fixed-fields-notice__desc strong {
  color: #0f172a;
  font-weight: 700;
}
.fixed-fields-notice__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 12px;
  align-items: center;
}
.fixed-fields-notice__action {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

/* Chips base */
.ffn-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  height: 26px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  box-sizing: border-box;
  white-space: nowrap;
}
.ffn-chip__check {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Chip azul (Nombre, Apellido, Correo) */
.ffn-chip--blue {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}
.ffn-chip__check--blue {
  background-color: #dbeafe;
}

/* Chip teal (Cargo/Posición) */
.ffn-chip--teal {
  background-color: #e6faf3;
  border: 1px solid #a7f3d0;
  color: #0f766e;
}
.ffn-chip__check--teal {
  background-color: #14b8a6;
}
</style>
